type Action =
  | {
      action: "login",
      returnPath?: string
    }
  | {
      action: "share",
      url: string
    }
  | {
      action: "close",
    }

const sendActionToApp = (action: Action) => {
  let handledBy: string[] = []

  // iOS
  const iOSHandler = (window as any).webkit?.messageHandlers?.['Fantasy']
  if (iOSHandler) {
    const json = JSON.stringify(action)
    iOSHandler.postMessage(json)
    handledBy.push('iOSHandler');
  }

  // Android
  const AndroidHandler = (window as any)['Fantasy']
  if (AndroidHandler) {
    const json = JSON.stringify(action)
    AndroidHandler.handleMessage(json)
    handledBy.push('androidHandler');
  }
  console.log("sendActionToApp", handledBy.length > 0 ? handledBy : 'NOT HANDLED', action)
}

const webviewActions = {
  login: (redirectAfterLogin?: string) => sendActionToApp({ action: 'login', returnPath: redirectAfterLogin }),
  share: (url: string) => sendActionToApp({ action: 'share', url }),
  close: () => sendActionToApp({ action: 'close' }),
}

export default webviewActions
